var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("AdminUserSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      tabChanged: _vm.tabChanged
    }
  }), _vm.isAuthorized ? _c("div", [_vm.selectedTab === _vm.tabs.users ? _c("div", [_c("UserListComponent", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm.selectedTab === _vm.tabs.signUpLink ? _c("div", [_c("UserSignupLinkList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e()]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };